export const accent = 'initial';